import React from 'react';
import { FadeUp } from './FadeUp';
export function WhoItsFor() {
  const audiences = [{
    emoji: '🚀',
    title: 'Entrepreneurs',
    desc: 'Who want their brand or project to look solid and credible from day one.'
  }, {
    emoji: '🏪',
    title: 'Businesses',
    desc: 'Local shops, e-commerce, or service providers looking to drive customers through Instagram.'
  }, {
    emoji: '🌟',
    title: 'Personal Brands',
    desc: 'Coaches, consultants, and freelancers who need to be seen as the go-to in their space.'
  }, {
    emoji: '💼',
    title: 'Professionals',
    desc: 'Doctors, lawyers, architects and more — who want to project confidence and credibility online.'
  }];
  return <section id="paraquien" className="relative z-10 text-center py-[72px] md:py-[100px]" data-id="element-250">
      <div className="max-w-[900px] mx-auto px-6" data-id="element-251">
        <span className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-cyan mb-4" data-id="element-252">
          Who is this for?
        </span>
        <FadeUp data-id="element-253">
          <h2 className="text-[clamp(26px,4vw,36px)] font-heading font-bold uppercase leading-[1.2] tracking-[0.05em] mb-6" data-id="element-254">
            Built for people who mean business
          </h2>
        </FadeUp>
        <FadeUp delay={0.1} data-id="element-255">
          <p className="text-white-dim text-base max-w-[560px] leading-[1.7] mx-auto mb-14" data-id="element-256">
            If you have something valuable to offer and want more people to see
            it — this service is for you.
          </p>
        </FadeUp>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-257">
          {audiences.map((aud, i) => <FadeUp key={i} delay={i * 0.08} data-id="element-258">
              <div className="bg-bg-card border border-cyan/10 rounded-sm p-[32px_20px] text-center transition-all duration-300 ease-in hover:border-cyan card-glow-hover-lg hover:-translate-y-1 h-full cursor-default" data-id="element-259">
                <span className="text-[36px] block mb-4" data-id="element-260">{aud.emoji}</span>
                <h4 className="text-[13px] font-heading font-semibold uppercase tracking-[0.05em] mb-2" data-id="element-261">
                  {aud.title}
                </h4>
                <p className="text-[12px] text-white-dim leading-[1.5]" data-id="element-262">
                  {aud.desc}
                </p>
              </div>
            </FadeUp>)}
        </div>
      </div>
    </section>;
}